import { peekItem, setItem, setItemWithExpiration } from '@alltrails/core/utils/localStorage';

// A user with the build_your_own_trail entitlement switched back to the standard builder and has not chosen Advanced since
const standardBuilderPreferredKey = 'custom-route-builder-prefers-standard';
// A user without the build_your_own_trail entitlement was sent to the advanced builder within the snooze window
const advancedBuilderRedirectKey = 'custom-route-builder-advanced-redirect';

export const ADVANCED_BUILDER_REDIRECT_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

// Peeked rather than read: these run on every render of the Build a route CTAs
export const isStandardBuilderPreferred = () => peekItem<boolean>(standardBuilderPreferredKey) === true;

// The shape setItemWithExpiration writes; an expired one is left for the next markAdvancedBuilderRedirect to overwrite
export const isAdvancedBuilderRedirectSnoozed = () => {
  const redirect = peekItem<{ timestamp: number; value: boolean }>(advancedBuilderRedirectKey);
  return redirect?.value === true && Date.now() < redirect.timestamp + ADVANCED_BUILDER_REDIRECT_SNOOZE_MS;
};

export const setStandardBuilderPreferred = (prefersStandard: boolean) => setItem(standardBuilderPreferredKey, prefersStandard);

export const markAdvancedBuilderRedirect = () => setItemWithExpiration(advancedBuilderRedirectKey, true);
